import React from 'react'
import classnames from 'classnames'
import { ClipLoader } from 'react-spinners'
import moment from 'moment'

export const ConversationView = ({ loading, loadingMoreMessages, messages, isReadOnly, loadMore, scrollPosition }) => {
  const containerView = React.useRef(null)
  const messagesView = React.useRef(null);

  React.useEffect(()=>{
    if(!!!scrollPosition) {
      containerView.current.scrollIntoView({ })
    } else {
      messagesView.current.scrollTop = scrollPosition - 40;
    }
  }, [messages])

  const handleOnScroll = (event) => {
    const target = event.target;
    if(target.scrollTop === 0 && !loading) {
      loadMore(target.scrollHeight);
    }
  }

  return (
    <div ref={messagesView} className="w-100 h-100" style={{overflowY: 'scroll'}} onScroll={handleOnScroll}>
      {
        isReadOnly && 
        <div className="bg-muted p-3 text-center">
          <small><b>This conversation is read only for clients.</b></small>
        </div>
      }
      {
        loadingMoreMessages && ( 
          <div className="d-flex justify-content-center align-items-center">
            <ClipLoader/>
          </div>
        )
      }
      {
        loading ?
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
          <ClipLoader/>
        </div> :
        <MessagesList messages={messages}/>
      }
      <div ref={containerView} className="w-100" style={{ height: '1px' }}/>
    </div>
  )
}

const MessagesList = ({ messages }) => (
  <>
    {
      messages.length > 0 &&
      messages.map(message=>(
        <Message key={message.id} message={message}/>
      ))
    }
  </>
)

const Message = ({ message }) => message.system ? 
  (
    <small className="p-3 text-secondary d-block text-center">
      { message.body }
    </small>
  ):
  (
    <div className={classnames("d-flex p-4 flex-column", { "align-items-end": message.isMine, "align-items-start": !message.isMine })}>
      <small className="text-secondary">{message.sender.name}</small>
      <div className={classnames('pt-2 pb-2 pl-3 pr-3 mt-1 mb-1 border-rounded text-right',{"bg-muted": !message.isMine, "bg-primary": message.isMine})}>
        {message.body}
      </div>
      <small className="text-secondary">{moment(message.createdAt).format("MM/DD/YYYY hh:mma")}</small>
    </div>
  )